import { Loader2 } from 'lucide-react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import PlusIcon from '@/assets/icons/plus-sm.svg';
import ViewGridAddIcon from '@/assets/icons/view-grid-add.svg';
import { CloseIcon } from '@/components/icons/close';
import { Button } from '@/components/ui/button';
import { useHireUrl } from '@/hooks/use-hire-url';
interface ActionButtonProps {
  activateChannel: () => void;
  deactivateChannel: () => void;
  isActivated: boolean;
  isActivating: boolean;
  isDeactivating: boolean;
  isJoveo: boolean;
}

export function ActionButton({
  activateChannel,
  deactivateChannel,
  isActivated,
  isActivating,
  isDeactivating,
  isJoveo,
}: ActionButtonProps) {
  const { hireConversionTrackingUrl } = useHireUrl();

  /* Loading state when activating or deactivating channel */
  if (isActivating || isDeactivating) {
    return (
      <Button variant="ghost" type="button">
        <Loader2 className="text-fx-primary animate-spin" />
        {isActivating && (
          <FormattedMessage
            defaultMessage="Activating"
            description="Activating channel"
          />
        )}
        {isDeactivating && (
          <FormattedMessage
            defaultMessage="Deactivating"
            description="Deactivating channel"
          />
        )}
      </Button>
    );
  }

  if (isActivated) {
    return (
      <>
        {/* Add Joveo pixel tracking button */}
        {isJoveo && (
          <Button variant="ghost" type="button" asChild>
            <Link to={hireConversionTrackingUrl} target="_blank">
              <img src={PlusIcon} alt="" />
              <FormattedMessage
                defaultMessage="Add Joveo pixel tracking"
                description="Button to add Joveo pixel tracking"
              />
            </Link>
          </Button>
        )}

        {/* Deactivate channel button */}
        <Button
          variant="ghost"
          type="button"
          onClick={deactivateChannel}
          className="text-fx-rose"
        >
          <CloseIcon className="text-fx-rose" />
          <FormattedMessage
            defaultMessage="Deactivate"
            description="Button to deactivate the channel"
          />
        </Button>
      </>
    );
  }

  /* Activate channel button */
  return (
    <Button variant="ghost" type="button" onClick={activateChannel}>
      <img src={ViewGridAddIcon} alt="Activate channel" />
      <FormattedMessage
        defaultMessage="Activate"
        description="Button to activate the channel"
      />
    </Button>
  );
}
